export default __webpack_public_path__ + "static/media/sodium.b6021414.jpg";